module.exports = "/images/Homepage-Laptop Illustration.jpg";